/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './EventListingsPublishDateField.module.scss';
import { formatDate } from '../../helpers/dateUtils';

import DatePicker from '../../../../common/components/Datepicker/Datepicker';

const dateOnlyConfig = {
  // format the date that gets written into the input (that will be sent in POST)
  dateFormat: 'Y-m-d',
  // disallow time input
  enableTime: false,
  // For post-selection display
  altInput: true,
  altFormat: 'm / d / Y',
  wrap: true,
};

const EventListingsPublishDateField = ({
  field,
  onChange,
  onClose,
  onReady = () => {},
  status,
}) => {
  const buttonRef = useRef(null);
  const fpRef = useRef(null);
  // const id = field.name;

  useEffect(() => {
    if (field.value && status === 'PAID') {
      if (new Date(field.value) < new Date()) {
        // eslint-disable-next-line no-underscore-dangle
        fpRef.current.flatpickr._input.disabled = true;
        buttonRef.current.disabled = true;
      }
    }
  }, [status]);

  useEffect(() => {
    if (field.value !== '') {
      // eslint-disable-next-line no-underscore-dangle
      fpRef.current.flatpickr._input.classList.add(styles.hidden);
    } else {
      // eslint-disable-next-line no-underscore-dangle
      fpRef.current.flatpickr._input.classList.remove(styles.hidden);
    }
  }, [field.value]);

  const isScheduled = field.value !== '';
  const scheduledDateStr = isScheduled ? formatDate(field.value) : '';

  return (
    <DatePicker
      ref={fpRef}
      config={dateOnlyConfig}
      description={`Specify when your event will begin to appear on ${window.siteName}`}
      labelText={field.label}
      name={field.name}
      onChange={onChange}
      onReady={onReady}
      onClose={onClose}
      placeholder={field.placeholder}
      required
      value={field.value}
      errorMsg={(field.touched && field.errors[0]) ? field.errors[0] : null}
    >
      <div className={styles.wrapperContainer}>
        <button
          ref={buttonRef}
          type="button"
          className={`publish-date-button ${styles.scheduledPublish} ${isScheduled ? '' : styles.hidden}`}
          onClick={() => fpRef.current.flatpickr.open()}
        >
          <div className={styles.scheduledPublishButtonText}>
            Scheduled to publish on <span className={styles.scheduledDateString}>{scheduledDateStr}</span>
          </div>
        </button>
        <input
          className={`datepicker flatpickr-input ${styles.scheduledInput} ${isScheduled ? styles.hidden : ''}`}
          name="publishDate"
          placeholder="MM / DD / YYYY"
          data-input
        />
      </div>
    </DatePicker>
  );
};

EventListingsPublishDateField.propTypes = {
  field: PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
    touched: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onReady: PropTypes.func,
  status: PropTypes.string.isRequired,
};

export default EventListingsPublishDateField;
